module.exports = __webpack_public_path__ + "static/media/landing1.a343575e.svg";